import React from 'react';
import classNames from 'classnames';

export const StepperStep: React.FC<{ icon: string; active?: boolean; finished?: boolean }> = ({
  icon,
  active = false,
  finished = false,
}) => {
  const classNameStates = {
    'is-finish': finished,
    'is-process': active,
    'is-wait': !active && !finished,
  };

  return (
    <div
      style={{
        flexBasis: '50%',
      }}
      className="el-step is-simple is-flex"
    >
      <div className={classNames('el-step__head', classNameStates)}>
        <div className="el-step__icon is-icon">
          <i className={`el-step__icon-inner el-icon-${icon}`} />
        </div>
      </div>
      <div className="el-step__main">
        <div className={classNames('el-step__title', classNameStates)} />
        <div className="el-step__arrow" />
      </div>
    </div>
  );
};
